/**
 * First party storage on the publisher's own domain, gated on consent.
 *
 * Every access is wrapped: Safari in private mode, a locked down enterprise browser and an iframe
 * with storage partitioned off all throw on the first property access, not on the call.
 */

export const DEVICE_KEY = 'quizee_did';

export function votedKey(interactionId: string): string {
  return `quizee_voted_${interactionId}`;
}

export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Quota, private mode or a blocked origin. Losing the write is fine, throwing is not.
  }
}
